export class Offer {
  public propertyId: number|null = 0
  public productId: number = 0
  public reference: string = ''
  public message: string = ''
  public municipalityNumber: string = ''
  public buildingNumber: string = ''
  public unitNumber: string = ''
  public address: string = ''
  public requestedDeliveryDate: string = ''
  public term: string = ''
  public isOrder: boolean = false
}
